import Rekv from "rekv";

export interface Todo {
  id: number;
  task: string;
  complete: boolean;
}

interface TodoList {
  taskId: number;
  todos: Todo[];
  editId?: number;
  editValue?: string;
}

const todoStore = new Rekv<TodoList>({
  taskId: 2,
  todos: [
    { id: 1, task: "待办1", complete: false },
    { id: 2, task: "待办2", complete: false }
  ]
});

export const actions = {
  addTodo(name: string) {
    todoStore.setState(s => {
      const [...todos] = s.todos;
      s.taskId++;
      const taskId = s.taskId;
      todos.push({
        id: taskId,
        task: name,
        complete: false
      });
      return {
        todos
      };
    });
  },

  toggleTodo(id: number) {
    todoStore.setState(s => {
      const todo = s.todos.find(item => item.id === id);
      if (todo) {
        todo.complete = !todo.complete;
      }
      return {
        todos: [...s.todos]
      };
    });
  },

  editTodo(id: number) {
    todoStore.setState({
      editId: id
    });
  },

  updateTodo(id: number, value: Todo) {
    todoStore.setState(s => {
      const [...todos] = s.todos;
      const todo = todos.find(item => item.id === id);
      if (todo) {
        Object.assign(todo, value);
        return {
          todos: [...todos]
        };
      }
      return {};
    });
  },

  removeTodo(id: number) {
    todoStore.setState(s => {
      const [...todos] = s.todos;
      return {
        todos: todos.filter(item => item.id !== id)
      };
    });
  }
};

export default todoStore;
